import { Institute } from "../../../interfaces/institute";
import { Tag } from "../../../interfaces/tag";
import { User } from "../../../interfaces/users/user";

export class Pathway {
	id: number;
	label: string;
	institute: Institute;
	tags: Tag[];
	status: EPathwayStatus;
	authors: User[];
	approvers: User[];
	managers: User[];
	last_update: string;
	current_status: string;
	content: PathwayContent;
	updates: PathwayUpdate[];

	constructor() {
		this.tags = [];
		this.authors = [];
		this.approvers = [];
		this.managers = [];
	}
}

export class PathwayContent {
	id: number;
	draft: string;
	published: string;
}

export enum EPathwayStatus {
	draft = 0, //offline
	published = 1, //online
	archived = 2,
}

export interface PathwayUpdate {
	id?: number;
	majorVersion: number;
	minorVersion: number;
	updated: Date;
	approver?: User;
	notes: string;
	authors: User[];
	approvers: User[];
	managers: User[];
	published: string;
	pathway: Pathway;
}
